import helpers from '../helpers';

class AsideMenu {
	constructor() {
		this.$toc = $('.article__toc');
		this.$articleBlocks = $('.article__toc-block');
		this.$links234 = this.$toc.find('.toc__link');
		this.$tocMobile = $('.toc-mobile');
		this.tocMobileBottom = 51;
		this.$btn = this.$toc.find('.toc-mobile__btn');
		this.$footer = $('footer');
		this.footerHeight = this.$footer.outerHeight();
		this.footerOffsetTop = this.$footer.offset().top;
		this.winHeight = helpers.winHeight;
		// this.init();
	}

	init() {
		this.resize();
		this.findScrollPos();
		this.setEvents();
	}

	setEvents() {
		this.$btn.on('click', (e) => {
			e.stopPropagation();
			this.$tocMobile.toggleClass('is-active');
		});

		$(document).on('click', () => {
			this.$tocMobile.removeClass('is-active');
		});

		const initHandler = () => {
			this.resize();
			this.findScrollPos();
		};

		const scrollHandler = () => {
			this.findScrollPos();
		};

		$(document).on('scroll', scrollHandler);
		$(window).on('load', initHandler);
		$(window).on('resize', initHandler);
	}

	resize() {
		this.footerHeight = this.$footer.outerHeight();
		this.footerOffsetTop = this.$footer.offset().top;
		this.winHeight = window.innerHeight;
		// this.tocMobileBottom = this.winHeight - this.$tocMobile.offset().top - this.$tocMobile.height();
		// console.log(this.footerOffsetTop, this.footerHeight);
	}

	findScrollPos() {
		const scroll = document.documentElement.scrollTop + this.winHeight / 2;
		const scrollBottom = document.documentElement.scrollTop + this.winHeight;

		this.$footer = $('footer');
		this.footerOffsetTop = this.$footer.offset().top;

		let activeFlag = false;
		for (let i = 0; i < this.$articleBlocks.length; i++) {
			const $el = this.$articleBlocks.eq(i);
			const posY = $el.offset().top;

			if (scroll >= posY) {
				activeFlag = true;
				this.$links234.each((_i, link) => {
					const $link = $(link);
					$link.removeClass('is-active');

					if ($link.attr('href') === `#${$el.attr('id')}`) {
						$link.addClass('is-active');
					}
				});
			}
		}
		if (!activeFlag) {
			this.$links234.removeClass('is-active');
		}

		if (scrollBottom > this.footerOffsetTop + this.tocMobileBottom) {
			this.$tocMobile.addClass('is-absolute');
			this.$tocMobile.css('bottom', this.footerHeight);
		} else {
			this.$tocMobile.removeClass('is-absolute');
			this.$tocMobile.css('bottom', '');
		}
	}

	destroy() {
		$(document).off('scroll', scrollHandler);
		$(window).off('load', initHandler);
		$(window).off('resize', initHandler);
	}
}

export default AsideMenu;
